
CTA_EVENT_ACTION = 'cta-click';
CTA_EVENT_CATEGORY_DEFAULT = 'cta-unknown';
CTA_EVENT_LABEL = 'User clicked on CTA button';

function addCtaClickListener() {
    const elements = document.querySelectorAll('[data-cta-click]');
    elements.forEach(element => {
        element.addEventListener('click', ((event) => {
            let analyticsCategory = CTA_EVENT_CATEGORY_DEFAULT;
            if (event && event.target && event.target.dataset && event.target.dataset.analyticsCategory){
                analyticsCategory=event.target.dataset.analyticsCategory;
            }
            gtag('event', this.CTA_EVENT_ACTION, {
                'event_category': analyticsCategory,
                'event_label': this.CTA_EVENT_LABEL
            });
        }));
    })
}

addCtaClickListener();
